function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n    .st5{fill:#e94c21}.st24,.st25,.st26{opacity:.5;fill:#e94c21}.st25,.st26{opacity:0}.st26{opacity:.2}.st54{display:inline;fill:#e5007d}\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M185.7 50.7c0 .7 0 1.2-.1 1.5h-23.2c.2 3.1 1.2 5.6 3 7.6 1.8 1.9 4.2 2.9 7.1 2.9 3.6 0 6.4-1.6 8.6-4.9l2.7 1.9c-2.5 4.2-6.3 6.4-11.4 6.4-4.1 0-7.5-1.4-10-4.3s-3.8-6.4-3.8-10.8c0-4.3 1.3-7.9 3.8-10.8 2.5-2.9 5.8-4.3 10-4.3 4 0 7.2 1.4 9.6 4.1 2.5 2.8 3.7 6.4 3.7 10.7zm-13.2-11.5c-2.8 0-5.1.9-6.9 2.8-1.8 1.8-2.8 4.3-3.1 7.3h19.8c-.3-3-1.3-5.4-3-7.3-1.7-1.9-4-2.8-6.8-2.8zM209.4 66c-2.3 0-4.2-.7-5.6-2.1-1.4-1.4-2.1-3.2-2.1-5.4V22h3.8l.1 36.5c0 1.4.3 2.4 1 3.1.7.7 1.6 1.1 2.9 1.1 1.3 0 2.3-.4 3.1-1.2l2.1 2.6c-1.3 1.3-3.1 1.9-5.3 1.9zM248.2 36.5h3.8v29h-3.5l-.2-4.4c-1 1.5-2.4 2.8-4.1 3.6-1.7.9-3.5 1.3-5.4 1.3-3.2 0-5.9-1.1-8.1-3.3-2.2-2.2-3.3-4.9-3.3-8.1V36.5h3.8v17.7c0 2.3.8 4.3 2.4 5.9 1.6 1.6 3.6 2.5 6 2.5s4.4-.8 6.1-2.5 2.5-3.6 2.5-5.9V36.5zM281.6 61.5l2.1 2.6c-1.3 1.3-3.1 2-5.3 2-2.3 0-4.2-.7-5.6-2.1-1.4-1.4-2.1-3.2-2.1-5.4v-19h-4v-3h4v-9.8h3.8v9.8h7.5v3h-7.5v19c0 1.4.3 2.4 1 3.1.7.7 1.7 1.1 2.9 1.1s2.4-.5 3.2-1.3zM322.3 50.7c0 .7 0 1.2-.1 1.5H299c.2 3.1 1.2 5.6 3 7.6 1.8 1.9 4.2 2.9 7.1 2.9 3.6 0 6.4-1.6 8.6-4.9l2.7 1.9c-2.5 4.2-6.3 6.4-11.4 6.4-4.1 0-7.5-1.4-10-4.3s-3.8-6.4-3.8-10.8c0-4.3 1.3-7.9 3.8-10.8 2.5-2.9 5.8-4.3 10-4.3 4 0 7.2 1.4 9.6 4.1 2.5 2.8 3.7 6.4 3.7 10.7zm-13.2-11.5c-2.8 0-5.1.9-6.9 2.8-1.8 1.8-2.8 4.3-3.1 7.3h19.8c-.3-3-1.3-5.4-3-7.3-1.7-1.9-4-2.8-6.8-2.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M79.6 26.5h13.2v13.2H79.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M79.6 66.1h13.2v13.2H79.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M92.8 52.9H106v13.2H92.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M92.8 39.7H106v13.2H92.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M66.4 66.1h13.2v13.2H66.4zM92.8 79.3H106v13.2H92.8zM106 66.1h13.2v13.2H106zM106 26.5h13.2v13.2H106z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M119.2 39.7h13.2v13.2h-13.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M92.8 26.5H106v13.2H92.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M106 39.7h13.2v13.2H106z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M106 52.9h13.2v13.2H106zM92.8 66.1H106v13.2H92.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M106 79.3h13.2v13.2H106z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M79.6 79.3h13.2v13.2H79.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M79.6 52.9h13.2v13.2H79.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M79.6 39.7h13.2v13.2H79.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M66.4 39.7h13.2v13.2H66.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M119.2 52.9h13.2v13.2h-13.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M119.2 66.1h13.2v13.2h-13.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M26.5 59.9c0 9.9 2.2 17.3 7.8 23.3 4.6 5 9.9 7.9 17.7 8.8 1.7.2 3.7.4 5.6.4h21.9V79.2H59.3c-1.6 0-3.4-.1-5-.3-5.9-.7-10.7-5.6-10.7-12.8L73 66c0-4.9-.1-9-.1-13.2H43.5c0-7.5 5.8-12.4 10.8-13 1.4-.1 3.6-.2 4.9-.2h20.2V26.4H56.8c-2.6 0-4.7.1-7.9.6-4.3.7-10.3 4-14.6 8.5-5.6 6.3-7.8 14.8-7.8 24.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M66.4 52.9h13.2v13.2H66.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M160.6 92.7V79.4h1.2v13.4h-1.2zM178.8 79.4h1.2v13.4h-1.1l-8.5-11.3v11.3h-1.2V79.4h1.1l8.5 11.3V79.4zM194.8 79.4v1.1h-3.7v12.3h-1.2V80.4h-3.7v-1.1h8.6zM208.1 80.4h-6v5.1h5.2v1.1h-5.2v5.1h6v1.1h-7.2V79.4h7.2v1zM214.7 92.7V79.4h1.2v12.3h5v1.1h-6.2zM227.2 92.7V79.4h1.2v12.3h5v1.1h-6.2zM239.7 92.7V79.4h1.2v13.4h-1.2zM254.6 80.3c-1.6 0-2.9.5-4 1.6S249 84.4 249 86c0 1.7.5 3 1.6 4.1 1.1 1.1 2.4 1.6 3.9 1.6.9 0 1.8-.2 2.6-.7v-4.2h-3.5v-1.1h4.5v6c-1.2.7-2.4 1.1-3.7 1.1-1.9 0-3.4-.7-4.7-2-1.3-1.3-1.9-2.9-1.9-4.9 0-2 .6-3.6 1.9-4.9 1.3-1.3 2.9-2 4.7-2 1.4 0 2.6.4 3.7 1.1v1.5c-.8-.8-2-1.3-3.5-1.3zM272.8 80.4h-6v5.1h5.2v1.1h-5.2v5.1h6v1.1h-7.2V79.4h7.2v1zM288.9 79.4h1.2v13.4H289l-8.5-11.3v11.3h-1.2V79.4h1.1l8.5 11.3V79.4zM302.7 92.9c-1.9 0-3.4-.7-4.7-2-1.2-1.3-1.9-2.9-1.9-4.9s.6-3.5 1.9-4.9c1.2-1.3 2.8-2 4.7-2 1.4 0 2.7.5 3.8 1.4V82c-1.1-1.2-2.4-1.7-3.8-1.7-1.6 0-2.9.5-3.9 1.6s-1.5 2.5-1.5 4.1c0 1.6.5 3 1.5 4s2.3 1.6 3.9 1.6c1.5 0 2.8-.6 3.8-1.7v1.5c-1 1-2.3 1.5-3.8 1.5zM320.1 80.4h-6v5.1h5.2v1.1h-5.2v5.1h6v1.1h-7.2V79.4h7.2v1z"
})));

function SvgLogoFullRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 348.8 119.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullRed);
export default __webpack_public_path__ + "static/media/logo-full-red.f802b9e8.svg";
export { ForwardRef as ReactComponent };